module.exports = __webpack_public_path__ + "img/SchwungImReifen.04cb92bc.svg";